import { render } from "./completed-scorecards.vue?vue&type=template&id=583e4f20&ts=true"
import script from "./completed-scorecards.vue?vue&type=script&lang=ts"
export * from "./completed-scorecards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__